import { WorkflowStateTypes } from './../model/workflow-state-types.model';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, switchMap, of, catchError, throwError } from 'rxjs';
import { BaseRestApiService } from 'src/app/service/baseRestApiService.service';
import { UrlProviderService, EndPoints } from 'src/app/service/urlprovider.service';

@Injectable({
    providedIn: 'root'
})
export class WorkflowStatesService extends BaseRestApiService {
    constructor(http: HttpClient, urlProvider: UrlProviderService) {
        super(http, urlProvider);
    }

    createWorkflowState(newState: WorkflowStateTypes, workflowId: number): Observable<any> {
        return this.post<any>(EndPoints.workflow_states_Create, false, null, { newState: newState, workflowId: workflowId }).pipe(
            switchMap((result) => {
                return of(result);
            }),
            catchError((err) => {
                return throwError(() => new Error(err));
            })
        );
    }

    updateWorkflowState(editState: WorkflowStateTypes): Observable<any> {
        return this.post<any>(EndPoints.workflow_states_Update, false, null, { editState: editState }).pipe(
            switchMap((result) => {
                return of(result);
            }),
            catchError((err) => {
                return throwError(() => new Error(err));
            })
        );
    }

    deleteWorkflowState(deleteState: WorkflowStateTypes): Observable<any> {
        return this.post<any>(EndPoints.workflow_states_Delete, false, null, { deleteState: deleteState }).pipe(
            switchMap((result) => {
                return of(result);
            }),
            catchError((err) => {
                return throwError(() => new Error(err));
            })
        );
    }
}
